import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { DPO_CONSTANT } from './../../utils/constant';
import { CacheService } from './../../services/cache.service';
import { AuthenticationService } from './../../services/authentication.service';
import { CommonService } from './../../services/common.service';
import { TranslateService} from '@ngx-translate/core';  //CAP-20457: LOT1.1: Translation Service changed to translate for JSON

@Component({
  selector: 'dpo-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  // Define the properties for the component
  @ViewChild('usernameInput', { static: true }) usernameInput: ElementRef;
  username: string;
  password: string;

  constructor(private toastrService: ToastrService,
    private cacheService: CacheService,
    private authenticationService: AuthenticationService,
    private translate:TranslateService,   //CAP-20457: LOT1.1: Translation Service changed to translate for JSON
    private commonService: CommonService) { }

  ngOnInit() {
    // Set the focus to the first textbox of the screen.
    setTimeout(() => {
      this.usernameInput.nativeElement.focus();
    }, 1000);
  }

  // Method to call the login API for the login into application
  login() {
    if (this.username && this.password) {
      // Prepare the data for login API
      let params: any = {
        userName: this.username ? this.username.trim() : '',
        password: this.password ? this.password.trim() : ''
      };
      // Call the login API with prepare data
      this.commonService.authenticateLogin(params).subscribe(response => {
        if (response) {
          this.cacheService.setItem(DPO_CONSTANT.CACHE_USER_ID, response['userName']);
	        this.cacheService.setItem(DPO_CONSTANT.CACHE_USER_TYPE, response['userType']);    // CAP-20753 : Setting the value UserType
          this.cacheService.setItem(DPO_CONSTANT.CACHE_APP_NAME, response['appName']);                                    //DAAS-49 : Get appName  from response and set to CACHE_APP_NAME
          this.authenticationService.authenticateUser(response['userRole'], response['userRoles'],response['appName'], response['country']);   //DAAS-49 : Added one more parameter to method; CAP-26096- Added country in response
        }
      }, error => {
        if (error && error.status && (error.status === 401 || error.status === 403 || error.status === 404) && error.error) {
          if(error.error === 'dpo.i18n.message.access.denied.servicebox'){
          this.toastrService.warning(this.translate.instant(error.error), this.translate.instant('dpo.i18n.message.toastr.warning'), {closeButton: true,});   //CAP-20457: LOT1.1: Translation Service changed to translate for JSON + close button added
          }
          else
          {
          this.toastrService.warning(this.translate.instant(error.error), this.translate.instant('dpo.i18n.message.toastr.warning'), {closeButton: true,});
          }
        } else {
          this.toastrService.error(this.translate.instant('dpo.i18n.message.record.error'), this.translate.instant('dpo.i18n.message.toastr.error'), {closeButton: true,});   //CAP-20457: LOT1.1: Translation Service changed to translate for JSON + close button added
        }
        this.username = '';
        this.password = '';
      })
    } else {
      this.toastrService.warning(this.translate.instant('dpo.i18n.message.login.credential.empty'), this.translate.instant('dpo.i18n.message.toastr.warning'), {closeButton: true,});  //CAP-20457: LOT1.1: Translation Service changed to translate for JSON + close button added
    }
  }

  // Method to close the window when user click's on cancel button
  cancel() {
    window.close();
  }
}
